<div class="flex justify-between w-full">
  <!-- Grade Selection -->
  <mat-form-field appearance="outline">
    <mat-label>Select Grade</mat-label>
    <mat-select
      [formControl]="gradeControl"
      (selectionChange)="onSelectionChange($event.value)"
      [value]="selectedGrade"
    >
      <ng-container>
        <mat-option
          class="hover:!bg-[#fae8e1] border-b"
          *ngFor="let grade of grades"
          [value]="grade"
        >
          {{ grade.name }}
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>

  <!-- Custom Grade Input -->
  <div class="flex relative justify-end" *ngIf="selectedGrade === 'Custom'">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Custom Grade</mat-label>
      <input matInput placeholder="Create Custom Grade" />
    </mat-form-field>
  </div>
</div>
